var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 43,
    viewBox: "0 0 45 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 33.4266V32.5183L44.9913 14.9772H29.3057L38.8573 5.98855L37.2795 4.52265C34.1421 1.60607 30.0789 0 25.8383 0C21.7285 0 17.7549 1.52865 14.6656 4.28995L6.64891 11.2628C6.24849 11.5808 5.85795 11.9207 5.48678 12.2735L4.71344 12.9747L4.72038 13.0516C1.71143 16.304 0 20.6693 0 25.1542C0 34.8355 7.66004 42.7119 17.0754 42.7119C20.9357 42.7119 24.6494 41.4344 27.6173 39.1409V42.2246H34.9747L45 33.4266Z",
    fill: "url(#paint0_linear_2343_4193)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5677 32.4587V17.5135H28.0963V21.6173H34.3478L32.9586 23.4762C31.2075 25.819 28.5678 27.1625 25.7161 27.1625C20.6615 27.1625 16.5493 22.9154 16.5493 17.6949C16.5493 12.4744 20.6615 8.22723 25.7161 8.22723C27.7014 8.22723 29.6468 8.90358 31.2297 10.1382L35.3204 6.1043C32.6497 3.73893 29.2545 2.44067 25.7161 2.44067C17.5719 2.44067 10.946 9.28359 10.946 17.6949C10.946 26.1061 17.5719 32.9492 25.7161 32.9492C29.9228 32.9492 33.9208 31.2051 36.6849 28.1647L38.6171 26.0397V32.4587H42.5677Z",
    fill: "#111111"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2343_4193",
    x1: -9.1919e-8,
    y1: 8.79625,
    x2: 41.2273,
    y2: 25.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460662,
    stopColor: "#C45CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21DE93"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGLogo);
export default __webpack_public_path__ + "static/media/g_logo.1f2367c91182a8dffd8b9650c8bee11e.svg";
export { ForwardRef as ReactComponent };